"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _of = require("rxjs/observable/of");

var _mergeMap = require("rxjs/operators/mergeMap");

var _reactRouterRedux = require("react-router-redux");

var _actions = require("settings-ui-sdk/Blogs/actions");

var _selectors = require("settings-ui-sdk/Blogs/selectors");

var _deleteBlogActions = require("../actions/staging/deleteBlogActions");

function redirectOnRequest($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.DeleteBlogActionTypes.REQUEST).pipe((0, _mergeMap.mergeMap)(function () {
    return (0, _of.of)((0, _reactRouterRedux.push)("website/blogs/" + (0, _selectors.getDefaultBlogId)(getState())));
  }));
}

function resetOnSuccess($action) {
  return $action.ofType(_actions.DeleteBlogActionTypes.SUCCESS).pipe((0, _mergeMap.mergeMap)(function () {
    return (0, _of.of)((0, _deleteBlogActions.resetDeleteBlogStage)());
  }));
}

var _default = (0, _reduxObservable.combineEpics)(redirectOnRequest, resetOnSuccess);

exports.default = _default;
module.exports = exports.default;